// Generic slug helper. Matches the convention used throughout the app
// ("Search & Sort" -> "search_sort") so routing/lookups stay consistent.
export function slugify(name) {
	return String(name == null ? "" : name)
		.replace(/[^A-Z0-9]+/gi, "_")
		.replace(/^_+|_+$/g, "")
		.toLowerCase();
}

export default slugify;
